"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activityCreateApi = activityCreateApi;
exports.activityDetailApi = activityDetailApi;
exports.activityListApi = activityListApi;
exports.activitySetIndexFlagApi = activitySetIndexFlagApi;
exports.activityUpdateApi = activityUpdateApi;
exports.activityUpdateSortApi = activityUpdateSortApi;
exports.drawReplyCreateApi = drawReplyCreateApi;
exports.drawReplyDeleteApi = drawReplyDeleteApi;
exports.drawReplyDetailApi = drawReplyDetailApi;
exports.drawReplyEnableListApi = drawReplyEnableListApi;
exports.drawReplyListApi = drawReplyListApi;
exports.drawReplyUpdateApi = drawReplyUpdateApi;
exports.getEnableQrcodeListApi = getEnableQrcodeListApi;
exports.getReplyListApi = getReplyListApi;
exports.homeMenuCreateApi = homeMenuCreateApi;
exports.homeMenuDeleteApi = homeMenuDeleteApi;
exports.homeMenuDetailApi = homeMenuDetailApi;
exports.homeMenuListApi = homeMenuListApi;
exports.homeMenuStatusToggleApi = homeMenuStatusToggleApi;
exports.homeMenuUpdateApi = homeMenuUpdateApi;
exports.joinRecordListApi = joinRecordListApi;
exports.joinRecordUpdateStatusApi = joinRecordUpdateStatusApi;
exports.lotteryActivityPrizeListApi = lotteryActivityPrizeListApi;
exports.lotteryActivityRecordCancelApi = lotteryActivityRecordCancelApi;
exports.lotteryActivityRecordDrawApi = lotteryActivityRecordDrawApi;
exports.lotteryActivityRecordListApi = lotteryActivityRecordListApi;
exports.lotteryActivityRecordNumApi = lotteryActivityRecordNumApi;
exports.lotteryActivityRecordStatusApi = lotteryActivityRecordStatusApi;
exports.lotteryActivityRecordUpdateApi = lotteryActivityRecordUpdateApi;
exports.lotteryActivityRecordUpdatePrizeApi = lotteryActivityRecordUpdatePrizeApi;
exports.lotteryRecordListApi = lotteryRecordListApi;
exports.lotteryRecordSetStatusApi = lotteryRecordSetStatusApi;
exports.redpacketConfigApi = redpacketConfigApi;
exports.redpacketUpdateConfigApi = redpacketUpdateConfigApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 活动列表
 * @param params
 */
function activityListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/draw/activity/page',
    method: 'GET',
    params: params
  });
}

/**
 * 新增商品
 * @param data
 */
function activityCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/draw/activity/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑商品
 * @param data
 */
function activityUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/draw/activity/update',
    method: 'POST',
    data: data
  });
}

/**
 * 商品详情
 * @param id
 */
function activityDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/draw/activity/detail/".concat(id),
    method: 'GET'
  });
}

/**
 * 单活动抽奖记录统计
 */
function lotteryActivityRecordNumApi(activityId) {
  return (0, _request.default)({
    url: "/admin/platform/draw/activity/statistics/".concat(activityId),
    method: 'GET'
  });
}

/**
 * 单活动抽奖记录列表
 */
function lotteryActivityRecordListApi(params) {
  return (0, _request.default)({
    url: '/admin/draw/JoinRecord/userRecords',
    method: 'POST',
    data: params
    // url: '/admin/platform/draw/activity/joinRecords/' + params.activityId,
    // method: 'GET',
    // params,
  });
}

/**
 * 活动奖项
 */
function lotteryActivityPrizeListApi(activityId) {
  return (0, _request.default)({
    url: "/admin/platform/draw/activity/prizes/".concat(activityId),
    method: 'GET'
  });
}

/**
 * 活动中奖奖品修改
 */
function lotteryActivityRecordUpdatePrizeApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/draw/activity/batchUpdateWins',
    method: 'POST',
    data: params
  });
}

/**
 * 单活动抽奖记录中奖状态修改
 */
function lotteryActivityRecordStatusApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/draw/activity/updatePhysicalWins',
    method: 'POST',
    data: params
  });
}

/**
 * 单活动抽奖记录批量修改
 */
function lotteryActivityRecordUpdateApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/draw/activity/batchUpdateWins',
    method: 'POST',
    data: params
  });
}

/**
 * 单活动抽奖记录取消中奖
 */
function lotteryActivityRecordCancelApi(params) {
  return (0, _request.default)({
    url: "/admin/platform/draw/activity/cancelWins/".concat(params.recordId),
    method: 'POST',
    data: params
  });
}

/**
 * 单活动抽奖开奖
 */
function lotteryActivityRecordDrawApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/draw/activity/winsDraw',
    method: 'POST',
    data: params
  });
}

/**
 * 抽奖记录列表
 */
function lotteryRecordListApi(params) {
  return (0, _request.default)({
    url: '/admin/draw/record/list',
    method: 'POST',
    data: params
  });
}

/**
 * 设置抽奖记录领取状态
 * @param data
 */
function lotteryRecordSetStatusApi(data) {
  return (0, _request.default)({
    url: '/admin/draw/record/update/status',
    method: 'POST',
    data: data
  });
}

/**
 * 设置抽奖活动首页展示状态
 * @param data
 */
function activitySetIndexFlagApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/draw/activity/set/index',
    method: 'POST',
    data: data
  });
}

/**
 * 设置抽奖活动排序
 * @param data
 */
function activityUpdateSortApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/draw/activity/updateSort',
    method: 'POST',
    data: data
  });
}

/**
 * 首页菜单列表
 * @param params
 */
function homeMenuListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/indexMenu/page',
    method: 'GET',
    params: params
  });
}

/**
 * 新增首页菜单
 * @param data
 */
function homeMenuCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/indexMenu/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑首页菜单
 * @param data
 */
function homeMenuUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/indexMenu/update',
    method: 'POST',
    data: data
  });
}

/**
 * 首页菜单状态切换
 */
function homeMenuStatusToggleApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/indexMenu/update/status/".concat(id),
    method: 'POST'
  });
}

/**
 * 删除首页菜单
 */
function homeMenuDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/indexMenu/delete/".concat(id),
    method: 'DELETE'
  });
}

/**
 * 首页菜单详情
 * @param id
 */
function homeMenuDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/indexMenu/detail/".concat(id),
    method: 'GET'
  });
}

/**
 * 获取所有启用状态的中奖锦鲤
 */
function getReplyListApi() {
  return (0, _request.default)({
    url: "/admin/platform/draw/reply/list/enable",
    method: 'GET'
  });
}

// 获取中奖锦鲤列表
function drawReplyListApi(para) {
  var data = {
    id: para.id,
    userName: para.userName,
    page: para.page,
    limit: para.limit,
    temp: para.temp
  };
  return (0, _request.default)({
    url: '/admin/platform/draw/reply/list',
    method: 'GET',
    params: data
  });
}

// 获取中奖锦鲤详情
function drawReplyDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/draw/reply/detail/".concat(id),
    method: 'get'
  });
}

// 新增中奖锦鲤
function drawReplyCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/draw/reply/save',
    method: 'post',
    data: data
  });
}

// 修改中奖锦鲤
function drawReplyUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/draw/reply/update',
    method: 'post',
    data: data
  });
}

// 删除中奖锦鲤
function drawReplyDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/draw/reply/delete/".concat(id),
    method: 'delete'
  });
}

// 获取所有启用的中奖锦鲤
function drawReplyEnableListApi() {
  return (0, _request.default)({
    url: '/admin/platform/draw/reply/list/enable',
    method: 'get'
  });
}

/**
 * 定时开奖记录列表
 */
function joinRecordListApi(data) {
  return (0, _request.default)({
    url: '/admin/draw/JoinRecord/list',
    method: 'POST',
    data: data
  });
}

/**
 * 更新定时开奖记录状态
 */
function joinRecordUpdateStatusApi(recordId) {
  var data = {
    recordId: recordId
  };
  return (0, _request.default)({
    url: '/admin/draw/JoinRecord/updateStatus',
    method: 'POST',
    data: data
  });
}

/**
 * 获取所有启用状态的弹窗二维码
 */
function getEnableQrcodeListApi() {
  return (0, _request.default)({
    url: '/admin/platform/qrcode/popup/list/enable',
    method: 'GET'
  });
}

/**
 * @description 获取红包配置
 */
function redpacketConfigApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/redpacket/config/getConfigs",
    method: 'GET'
  });
}

/**
 * 定时开奖记录列表
 */
function redpacketUpdateConfigApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/redpacket/config/saveConfigs',
    method: 'POST',
    data: data
  });
}